// redux utils
import { createAsyncThunk } from '@reduxjs/toolkit';
import store from '../store/store'
// api
import * as pa from './api/pa'
import * as ppa from './api/ppa'
import * as comment from './api/comment'
import { downloadLink } from '@insticator/insticator-ui/dist/utils/files.js';
import {displayErrorMessage, displaySuccessMessage, exportcsv, log} from '@insticator/insticator-ui'

// thunks
export const fetchTotalCommentsReport = createAsyncThunk(
    'commenting/fetchTotalCommentsReport',
    async ({ requestData }) => {
        const response = await pa.postTotalCommentsRequest({ requestData });
        return response.data
    }
);

export const fetchTotalCommentingViewsReport = createAsyncThunk(
  'commenting/fetchTotalCommentingViewsReport',
  async ({ requestData }) => {
      const response = await pa.postTotalCommentingViewsRequest({ requestData });
      return response.data
  }
);

export const fetchCommentingUsersReport = createAsyncThunk(
    'commenting/fetchCommentingUsersReport',
    async ({ requestData }) => {
        const response = await pa.postCommentingUsersRequest({ requestData });
        return response.data
    }
);

export const fetchTotalCommentingReactionsReport = createAsyncThunk(
    'commenting/fetchCommentingReactionsReport',
    async ({ requestData }) => {
        const response = await pa.postTotalCommentingReactionsRequest({ requestData });
        return response.data
    }
);

export const fetchTopArticlesReport = createAsyncThunk(
    'commenting/fetchTopArticlesReport',
    async ({ requestData }) => {
        const response = await pa.postTopArticlesRequest({ requestData });
        return response.data
    }
);

export const fetchCommentingBeelineReport = createAsyncThunk(
    'commenting/fetchCommentingBeelineReport',
    async ({ requestData }) => {
        const response = await pa.postCommentingBeelineRequest({ requestData });
        return response.data
    }
);

export const fetchEmailsSentReport = createAsyncThunk(
    'commenting/fetchEmailsSentReport',
    async ({ requestData }) => {
        const response = await pa.postEmailsSentRequest({ requestData });
        return response.data
    }
);

export const fetchAvgInViewReport = createAsyncThunk(
    'commenting/fetchAvgInViewReport',
    async ({ requestData }) => {
        const response = await pa.postCommentingAvgInViewData({ requestData });
        return response.data
    }
);

export const fetchTopArticlesExportAll = createAsyncThunk(
    'commenting/fetchTopArticlesExportAll',
    async (requestData) => {
        const response = await pa.postTopArticlesExportAllRequest(requestData);
        if(response?.data?.exportedFileUrl){
            //download file
            downloadLink(response.data.exportedFileUrl)
        }
        return response.data
    }
);

export const createCustomCommentingRole = createAsyncThunk('commenting/createCustomCommentingRole',
    async (payload, { rejectWithValue }) => {
        const { accountUUID, roleName, customImage } = payload
        try {
            const formData = new FormData()
            formData.append('accountUUID', accountUUID)
            formData.append('roleName', roleName)
            formData.append('customImage', customImage)
            const response = await ppa.createCustomCommentingRole(formData)
            store.dispatch(displaySuccessMessage('Custom commenting role has been added successfully'))
            return response.data
            
        } catch(err) {
            const errResponse = rejectWithValue(err.response.data);
            const error = errResponse?.payload || 'There was an issue adding this role'
            store.dispatch(displayErrorMessage(error))
            return errResponse
        }
    }
);

export const updateCustomCommentingRole = createAsyncThunk('commenting/updateCustomCommentingRole',
    async (payload, { rejectWithValue }) => {
        const { accountUUID, roleName, customImage, badgeImageURL, roleUUID } = payload
        try {
            const formData = new FormData()
            formData.append('accountUUID', accountUUID)
            formData.append('roleName', roleName)
            if(customImage) formData.append('customImage', customImage)
            if(badgeImageURL) formData.append('badgeImageURL', badgeImageURL)
            const response = await ppa.updateCustomCommentingRole(roleUUID, formData)
            store.dispatch(displaySuccessMessage('Custom commenting role has been updated successfully'))
            return response.data
            
        } catch(err) {
            const errResponse = rejectWithValue(err.response.data);
            const error = errResponse?.payload || 'There was an issue updating this role'
            store.dispatch(displayErrorMessage(error))
            return errResponse
        }
    }
);

export const createNewImport = createAsyncThunk('commenting/createNewImport',
    async (payload, { rejectWithValue }) => {
        const { file } = payload
        log('payload', payload)
        try {
            const importData = new FormData()
            importData.append('file', file)
            const payloadRequest = {...payload}
            delete payloadRequest.file
            importData.append("request", JSON.stringify(payloadRequest))
            const response = await comment.createNewImport({requestData: importData})
            store.dispatch(displaySuccessMessage('New import started successfully'))
            return response.data
            
        } catch(err) {
            const errResponse = rejectWithValue(err.response.data);
            const error = 'There was an issue starting this new import'
            store.dispatch(displayErrorMessage(error))
            return errResponse
        }
    }
);

export const importDisqusAPI = createAsyncThunk('commenting/importDisqusAPI',
    async (payload, { rejectWithValue }) => {
        console.log('payload', payload)
        const importPayload = {...payload}
        importPayload.commentingUnitId = payload.integrationId
        delete importPayload.integrationId
        try {
            const response = await comment.importDisqusAPI(importPayload)
            store.dispatch(displaySuccessMessage('New import (disqus API) started successfully'))
            return response.data
        } catch(err) {
            const errResponse = rejectWithValue(err.response.data);
            const error = 'There was an issue starting this new import'
            store.dispatch(displayErrorMessage(error))
            return errResponse
        }
    }
);

const defaultClientMessage = `##Sample Heading\n\nThis is a sample message to showcase what's possible via this feature. You can add different formatting like **bold**, *italics*, and even [links](https://www.insticator.com/)!\n\nSimply replace all of the copy in this textbox with your message. You can see a live preview below and even sample what the message would look like in your commenting unit by clicking the “Test Page” button at the top of the page.`
export const fetchCommentingConfig = createAsyncThunk('comment/fetchCommentingConfig',
    async payload => {
      const { accountUUID, siteUUID, siteURL } = payload
      const response = await comment.fetchCommentingConfig({accountUUID, siteUUID, siteURL})
      if (response?.data?.general) {
        if (!response.data.general.clientMessage) {
          response.data.general.clientMessage = defaultClientMessage
        }
      }
      return response.data
    }
);

export const fetchCommentingRequestStatus = createAsyncThunk('commenting/fetchCommentingRequestStatus',
    async accountUUID => {
      const response = await comment.fetchCommentingRequestStatus(accountUUID)
      return response.data
    }
);

export const approveCommentingAccessRequest = createAsyncThunk('commenting/approveCommentingAccessRequest',
  async (payload, { rejectWithValue }) => {
      const { accountUUID, userEmail } = payload
      try {
        const response = await comment.approveCommentingAccessRequest(accountUUID)
        // if logged in non-internal user sent the request
        if(userEmail) {
          store.dispatch(displaySuccessMessage('Your request was sent successfully'))
          return {
            userEmail,
            accountUUID,
            requestStatus: 'PENDING' 
          }
        }
        // if mocked user sent the request
        return response.data
      } catch(err) {
        const error = `There was an issue approving this account`
        store.dispatch(displayErrorMessage(error))
        return null
      }
  }
);

export const fetchCommentingUnitCode = createAsyncThunk('comment/fetchCommentingUnitCode',
    async payload => {
      const { siteUUID } = payload
      const response = await comment.fetchCommentingUnitCode(siteUUID)
      return response.data
    }
);

export const cancelImport = createAsyncThunk('commenting/cancelImport',
    async (payload, { rejectWithValue }) => {
        const { id, integrationId, vendor } = payload
        try {
            const response = await comment.cancelImport({id, integrationId, vendor})
            store.dispatch(displaySuccessMessage('Import succcessfully cancelled'))
            return true
            
        } catch(err) {
            const errResponse = rejectWithValue(err.response.data);
            const error = 'There was an issue cancelling this import'
            store.dispatch(displayErrorMessage(error))
        }
    }
);

export const fetchImportLists = createAsyncThunk('comment/fetchImportLists',
    async payload => {
      const { integrationId } = payload
      const response = await comment.fetchImportLists(integrationId)
      return response.data?.response || {}
    }
);

export const getTopThreadsExamples = createAsyncThunk('comment/getTopThreadsExamples',
    async payload => {
      const { integrationId, limit } = payload
      const response = await comment.getTopThreadsExamples({integrationId, limit})
      return response.data?.response || {}
    }
);


export const getUpdatedCodes = createAsyncThunk('commenting/getUpdatedCodes',
    async siteUUID => {
      const response = await comment.getUpdatedCodes(siteUUID)
      return response.data
    }
);

export const getMigrationStatus = createAsyncThunk('commenting/getMigrationStatus',
    async commentingUnitUUID => {
      const response = await comment.getMigrationStatus(commentingUnitUUID)
      return response.data
    }
);

export const updateMigrationStatus = createAsyncThunk('commenting/updateMigrationStatus',
  async (payload, { rejectWithValue }) => {
      try {
        const { commentingUnitUUID, status } = payload
        const response = await comment.updateMigrationStatus(commentingUnitUUID, status)
        store.dispatch(displaySuccessMessage('Successfully started a new migration'))
        return response.data // newCommentingUnitUUID
      } catch(err) {
          const error = 'There was an issue starting this migration'
          store.dispatch(displayErrorMessage(error))
          return null
      }
  }
);

export const exportCommentingData = createAsyncThunk('commenting/exportCommentingData',
  async (payload, { rejectWithValue }) => {
      try {
        const { commentingUnitUUID, format } = payload
        const response = await comment.getExportData(commentingUnitUUID, format)
        exportcsv(response.data, `userprofiles.${format.toLowerCase()}`, null);
        return response.data
      } catch(err) {
        const errResponse = rejectWithValue(err).payload.response;
        log('export error', errResponse)
        let errorMessage = errResponse.status === 400 ? 'No commenting data recorded yet to the selected site.' : 'There was an error on exporting the commenting analytics.';
        store.dispatch(displayErrorMessage(errorMessage))
        return null
      }
  }
);

// commenting add ons
export const getAddOns = createAsyncThunk('commenting/getAddOns',
    async payload => {
      const { siteUUID } = payload
      const response = await comment.getAddOns(siteUUID)
      return response.data
    }
);

// TODO: Remove this when addons got moved from configuration page
// comments counter code
export const getCommentsCounterCode = createAsyncThunk('commenting/getCommentsCounterCode',
    async payload => {
      const { siteUUID } = payload
      const response = await comment.getAddOns(siteUUID)
      return response.data
    }
);

export const createAddOnsSetting = createAsyncThunk('commenting/createAddOnsSetting',
  async (payload, { rejectWithValue }) => {
      const { type, data, label } = payload
      try {
        const response = await comment.createAddOnsSetting({type, request: data})
        store.dispatch(displaySuccessMessage(`${label} add-ons setting created.`))
        return {
          type: type === 'community' ? type : 'commentsCounter',
          data: response.data
        }
      } catch(err) {
        const error = `There was an issue creating the ${label} add-ons setting.`
        store.dispatch(displayErrorMessage(error))
        return null
      }
  }
);

export const updateAddOnsSetting = createAsyncThunk('commenting/updateAddOnsSetting',
  async (payload, { rejectWithValue }) => {
      const { configurationUUID, type, label, data } = payload
      try {
        const response = await comment.updateAddOnsSetting({type, configurationUUID, request: data})
        store.dispatch(displaySuccessMessage(`${label} add-ons setting updated.`))
        return {
          type: type === 'community' ? type : 'commentsCounter',
          data
        }
      } catch(err) {
        const error = `There was an issue updating the ${label} add-ons setting.`
        store.dispatch(displayErrorMessage(error))
        return null
      }
  }
);

export const updateAvatarPack = createAsyncThunk('commenting/updateConfigAvatarPack',
    async (payload, { rejectWithValue }) => {
        const { avatarPack, commentingUnitConfigurationUUID } = payload
        try {
            const response = await comment.updateAvatarPack({commentingUnitConfigurationUUID, avatarData: {avatarPack}});
            store.dispatch(displaySuccessMessage('Commenting user avatar pack config updated.'))
            return { data: avatarPack }
            
        } catch(err) {
            const errResponse = rejectWithValue(err.response.data);
            const error = errResponse?.payload || 'There was an issue updating this avatar configuration.'
            store.dispatch(displayErrorMessage(error))
            return errResponse
        }
    }
);

export const updateCommentsTree = createAsyncThunk('commenting/updateConfigCommentsTree',
    async (payload, { rejectWithValue }) => {
        const { commentsTree, commentTreeConfigurationUUID } = payload
        try {
            const response = await comment.updateCommentsTree({commentTreeConfigurationUUID, commentsTreeData: {...commentsTree}});
            store.dispatch(displaySuccessMessage('Commenting comments tree config updated.'))
            return { data: {...commentsTree} }
            
        } catch(err) {
            const errResponse = rejectWithValue(err.response.data);
            const error = errResponse?.payload || 'There was an issue updating this comments tree configuration.'
            store.dispatch(displayErrorMessage(error))
            return errResponse
        }
    }
);

export const updateColorSchema = createAsyncThunk('commenting/updateConfigColorSchema',
    async (payload, { rejectWithValue }) => {
        const { colorSchema, colorSchemaConfigurationUUID } = payload
        try {
          const colorSchemaData = {...colorSchema}
          Object.keys(colorSchemaData).map(color => {
            if(color !== 'uuid') colorSchemaData[color] = colorSchemaData[color].replace('#', '').toUpperCase()
          });
          const response = await comment.updateColorSchema({colorSchemaConfigurationUUID, colorSchemaData});
          store.dispatch(displaySuccessMessage('Commenting color schema config updated.'))
          return { data: {...colorSchemaData} }
            
        } catch(err) {
          const errResponse = rejectWithValue(err.response.data);
          const error = errResponse?.payload || 'There was an issue updating this color schema configuration.'
          store.dispatch(displayErrorMessage(error))
          return errResponse
        }
    }
);

export const updateCommunity = createAsyncThunk('commenting/updateConfigCommunity',
    async (payload, { rejectWithValue }) => {
        const { community, communityConfigurationUUID, commentingUnitUUID } = payload
        let placeholderImageUrl = community.placeholderImageUrl || null

        try {
            if(community.placeholderImage && community.placeholderImageType === 'custom') {
              const data = new FormData();
              data.append('commentingUnitUUID', commentingUnitUUID);
              data.append('image', community.placeholderImage, community.placeholderImage.name);
              data.append('workflow', 'COMMUNITY');
              const uploadImageResponse = await comment.uploadCommentingImage(data)
              placeholderImageUrl = uploadImageResponse.data.imageUrl
            }

            if(community.placeholderImageType === 'standard') placeholderImageUrl = null
    
            community.placeholderImageUrl = placeholderImageUrl
            
            const response = await comment.updateCommunity({communityConfigurationUUID, communityData: {...community}});
            store.dispatch(displaySuccessMessage('Commenting community config updated.'))
            return { data: {...community} }
            
        } catch(err) {
            const errResponse = rejectWithValue(err.response.data);
            const error = errResponse?.payload || 'There was an issue updating this community configuration.'
            store.dispatch(displayErrorMessage(error))
            return errResponse
        }
    }
);

export const updateModeration = createAsyncThunk('commenting/updateConfigModeration',
    async (payload, { rejectWithValue }) => {
        const { moderation, moderationConfigurationUUID } = payload
        try {
            const response = await comment.updateModeration({moderationConfigurationUUID, moderationData: {...moderation}});
            store.dispatch(displaySuccessMessage('Commenting moderation config updated.'))
            return { data: {...moderation} }
            
        } catch(err) {
            const errResponse = rejectWithValue(err.response.data);
            const error = errResponse?.payload || 'There was an issue updating this moderation configuration.'
            store.dispatch(displayErrorMessage(error))
            return errResponse
        }
    }
);

export const updateGeneral = createAsyncThunk('commenting/updateConfigGeneral',
    async (payload, { rejectWithValue }) => {
        const { general, commentingUnitConfigurationUUID } = payload
        try {
            const response = await comment.updateGeneral({commentingUnitConfigurationUUID, generalData: {...general}});
            store.dispatch(displaySuccessMessage('Commenting general config updated.'))
            return { data: {...general} }
            
        } catch(err) {
            const errResponse = rejectWithValue(err.response.data);
            const error = errResponse?.payload || 'There was an issue updating this general configuration.'
            store.dispatch(displayErrorMessage(error))
            return errResponse
        }
    }
);

// Commenting 2.0 
export const getTopArticlesExamples = createAsyncThunk('comment/getTopArticlesExamples',
    async payload => {
      const { commentingUnitId, limit } = payload
      const response = await comment.getTopArticlesExamples({commentingUnitId, limit})
      console.log('response', response)
      return response.data || {}
    }
);

export const fetchCommentingConfigV2 = createAsyncThunk('comment/fetchCommentingConfigV2',
    async payload => {
      const { siteUUID } = payload
      const response = await comment.fetchCommentingConfigV2({ siteUUID })
      return response.data
    }
);

export const fetchCommentingV2DisplayConfig = createAsyncThunk('comment/fetchCommentingV2DisplayConfig',
    async payload => {
      const { siteId } = payload
      const response = await comment.fetchCommentingV2DisplayConfig({ siteId })
      return response.data
    }
);

export const fetchEmojisCategories = createAsyncThunk('comment/fetchCommentingV2EmojisCategories',
    async () => {
      const response = await comment.fetchEmojisCategories()
      return response.data
    }
);

export const updateGeneralConfig = createAsyncThunk('comment/updateCommentingGeneralConfig',
    async (payload, { rejectWithValue }) => {
        const { generalConfig, commentingUnitId } = payload
        try {
            const response = await comment.updateGeneralConfig({ commentingUnitId: commentingUnitId, data: generalConfig })
            store.dispatch(displaySuccessMessage('General config updated.'))
            return {...generalConfig}
            
        } catch(err) {
            const errResponse = err.response ? rejectWithValue(err.response.data) : null
            let error = 'There was an issue updating general config'
            if(errResponse) error = errResponse.payload && typeof errResponse.payload === 'string' ? errResponse.payload : error
            store.dispatch(displayErrorMessage(error))
            return errResponse
        }
    }
);

export const updateAdminConfig = createAsyncThunk('comment/updateCommentingAdminConfig',
    async (payload, { rejectWithValue }) => {
        const { adminConfig, commentingUnitId } = payload
        try {
            const response = await comment.updateAdminConfig({ commentingUnitId: commentingUnitId, data: adminConfig })
            store.dispatch(displaySuccessMessage('Admin config updated.'))
            return {...adminConfig}
            
        } catch(err) {
            const errResponse = err.response ? rejectWithValue(err.response.data) : null
            let error = 'There was an issue updating admin config'
            if(errResponse) error = errResponse.payload && typeof errResponse.payload === 'string' ? errResponse.payload : error
            store.dispatch(displayErrorMessage(error))
            return errResponse
        }
    }
);

export const updateAdsConfig = createAsyncThunk('comment/updateCommentingAdsConfig',
    async (payload, { rejectWithValue }) => {
        const { adsConfig } = payload
        try {
            const response = await comment.updateAdsConfig({ data: adsConfig})
            store.dispatch(displaySuccessMessage('Ads config updated.'))
            return {...adsConfig}
            
        } catch(err) {
            const errResponse = err.response ? rejectWithValue(err.response.data) : null
            let error = 'There was an issue updating ads config'
            if(errResponse) error = errResponse.payload && typeof errResponse.payload === 'string' ? errResponse.payload : error
            store.dispatch(displayErrorMessage(error))
            return errResponse
        }
    }
);


export const updateAdvancedConfig = createAsyncThunk('comment/updateCommentingAdvancedConfig',
    async (payload, { rejectWithValue }) => {
        const { advancedConfig, commentingUnitId } = payload
        try {
            const response = await comment.updateAdvancedConfig({ commentingUnitId: commentingUnitId, data: advancedConfig })
            store.dispatch(displaySuccessMessage('Advanced config updated.'))
            return {...advancedConfig}
            
        } catch(err) {
            const errResponse = err.response ? rejectWithValue(err.response.data) : null
            let error = 'There was an issue updating advanced config'
            if(errResponse) error = errResponse.payload && typeof errResponse.payload === 'string' ? errResponse.payload : error
            store.dispatch(displayErrorMessage(error))
            return errResponse
        }
    }
);

export const updateDisplayConfig = createAsyncThunk('comment/updateDisplayConfig',
    async (payload, { rejectWithValue, getState }) => {
        const { displayConfig, emojis, siteId, applyForAllProducts = false } = payload
        const state = getState();
        const emojiCategoriesList = state.commentingV2.emojiCategories // fetch all of the emoji categories

        log(displayConfig)
    
        try {
            const emojiRequests = emojis.map(emoji => {
                const { emojiName, emojiCategoryType } = emoji.emojiCategory // get the current emoji name and category type 
                const newEmojiCategory = displayConfig.emojiCategoryType || emojiCategoryType

                // mapped the emojiCategoryUUID from the emoji cateogires list
                const mappedEmojiCategoryUUID = emojiCategoriesList.find(emojiCategory => 
                    emojiCategory.emojiName === emojiName && emojiCategory.emojiCategoryType === newEmojiCategory
                )?.emojiCategoryUUID 

                return {
                    emojiUUID: emoji.emojiUUID,
                    emojiCategoryUUID: mappedEmojiCategoryUUID,
                    active: emoji.active,
                    emojiName
                }
            })

            const newEmojis = emojis.map(emoji => {
                const { emojiName, emojiCategoryType } = emoji.emojiCategory // get the current emoji name and category type 
                const newEmojiCategory = displayConfig.emojiCategoryType || emojiCategoryType

                // mapped the emojiCategoryUUID from the emoji cateogires list
                const mappedEmojiCategory = emojiCategoriesList.find(emojiCategory => 
                    emojiCategory.emojiName === emojiName && emojiCategory.emojiCategoryType === newEmojiCategory
                )

                return { 
                    ...emoji,
                    emojiCategory: mappedEmojiCategory
                }
            })

            log('emoji requests', emojiRequests, newEmojis)

            const response = await comment.updateDisplayConfig({ siteId: siteId, data: {
                config: displayConfig,
                applyForAllProducts,
                emojiRequests
            } })
            store.dispatch(displaySuccessMessage('Display config updated.'))
            log('display config', displayConfig)
            return {config: displayConfig, emojis: newEmojis}
            
        } catch(err) {
            const errResponse = err.response ? rejectWithValue(err.response.data) : null
            const error = 'There was an issue updating display config'
            store.dispatch(displayErrorMessage(error))
            return errResponse
        }
    }
);

export const updateCommentingDisplayConfig = createAsyncThunk('comment/updateCommentingDisplayConfig',
    async (payload, { rejectWithValue }) => {
        const { data, commentingUnitId } = payload
        log('payload', payload)
        try {
            const response = await comment.updateDisplayConfigV2({ commentingUnitId: commentingUnitId, data: {...data} })
            store.dispatch(displaySuccessMessage('Site themes config updated.'))
            return {...response.data} 
            
        } catch(err) {
            const errResponse = err.response ? rejectWithValue(err.response.data) : null
            const error = 'There was an issue updating site themes config'
            store.dispatch(displayErrorMessage(error))
            return errResponse
        }
    }
);
